import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReCAPTCHA } from 'react-google-recaptcha';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import { disclaimer } from './constants';
import { submitInquiries } from '../../services';
import * as styles from './styles.module.css';
import ContactForm from './ContactForm';
import MainForm from './MainForm';

const InquiriesForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [captcha, setCaptcha] = useState({ response: '', expired: false });
  const onChange = (value) => {
    if (value) {
      setCaptcha({ response: value, expired: false });
    } else {
      // expired
      setCaptcha({ response: '', expired: true });
    }
  };
  const onSubmit = (data) => {
    const payload = {
      lead_source: 'Web-To-Lead Form',
      captcha_settings: {
        keyname: 'fabfitfunWebLead',
        fallback: true,
        orgId: '00D36000000u0it',
        ts: new Date().getTime(),
      },
      oid: '00D36000000u0it',
      retURL: 'https://fabfitfun.com/get-the-box/',
      'g-recaptcha-response': captcha.response,
      submit: 'Submit',
      ...data,
    };
    if (captcha.response !== '' && !captcha.expired) {
      submitInquiries(payload).then(() => {
        window.location.href = `${process.env.REACT_APP_SITE_URL}my-account`;
      });
    }
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={styles['inquiries__form']}
      data-testid="form"
    >
      <MainForm register={register} errors={errors} />
      <ContactForm register={register} errors={errors} />
      <FFFErrorBoundary fallbackUI={<h3 style={{ color: 'red' }}>Something went wrong.</h3>}>
        <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={onChange} />
      </FFFErrorBoundary>
      <br />
      <input type="submit" data-testid="submit" />
      <p>
        <small>{disclaimer}</small>
      </p>
    </form>
  );
};

export default InquiriesForm;
